<template>
  <div class="detail-template w-full h-full">
    <slot :scope="scopeItem" :selected="isSelected" :inEdit="isInEdit" :expanded="isExpanded" :save="updateDataItem" :cancel="resetScopeItem" :select="setSelected" :edit="setInEdit" :expand="setExpanded">

      <span> {{JSON.stringify(dataItem)}} </span>
    </slot>
  </div>
</template>
<script>
import getNestedValue from '@/services/functions/getNestedValue'
import setNestedValue from '@/services/functions/setNestedValue'
import { cloneDeep, merge } from 'lodash'

export default {
  name: 'detail-template',
  props: {
    dataItem: Object,
    dataIndex: Number,
    selectedField: {
      type: String,
      default: 'selected'
    },
    expandField: {
      type: String,
      default: 'expanded'
    },
    editField: {
      type: String,
      default: 'inEdit'
    }
  },
  data () {
    return {
      scopeItem: null
    }
  },
  created () {
    this.resetScopeItem(true)
  },
  computed: {
    isSelected: {
      get: function () {
        return getNestedValue(this.selectedField, this.dataItem)
      },
      set: function (value) {
        setNestedValue(this.selectedField, this.dataItem, value)
        setNestedValue(this.selectedField, this.scopeItem, value)
      }
    },
    isInEdit: {
      get: function () {
        return getNestedValue(this.editField, this.dataItem)
      },
      set: function (value) {
        setNestedValue(this.editField, this.dataItem, value)
        setNestedValue(this.editField, this.scopeItem, value)
      }
    },
    isExpanded: {
      get: function () {
        return getNestedValue(this.expandField, this.dataItem)
      },
      set: function (value) {
        setNestedValue(this.expandField, this.dataItem, value)
        setNestedValue(this.expandField, this.scopeItem, value)
      }
    },
  },
  methods: {
    updateDataItem: function (keepEdit = false) {
      merge(this.dataItem, this.scopeItem)
      if (!keepEdit) {
        this.setInEdit(false)
      }
      this.$emit('change', { dataItem: this.dataItem })
    },
    resetScopeItem: function (keepEdit = false) {
      this.scopeItem = cloneDeep(this.dataItem)
      if (!keepEdit) {
        this.setInEdit(false)
      }
    },
    setSelected: function (value) {
      this.isSelected = value
    },
    setInEdit: function (value) {
      this.isInEdit = value
    },
    setExpanded: function (value) {
      this.isExpanded = value
    }
  },
}
</script>
